// DEMO CONTEXT - REMOVE IN PRODUCTION
// This context is for demo purposes only to manage portrait ratio state
// To disable: Comment out the import and usage in the main component
// To enable: Uncomment the import and usage

import React, { createContext, useContext, useState, ReactNode } from 'react';
import type { PortraitRatio } from '@/components/demo/demoRatio';

interface DemoContextType {
    portraitRatio: PortraitRatio;
    setPortraitRatio: (ratio: PortraitRatio) => void;
    isDemoMode: boolean;
}

const DemoContext = createContext<DemoContextType | undefined>(undefined);

interface DemoProviderProps {
    children: ReactNode;
}

export function DemoProvider({ children }: DemoProviderProps) {
    const [portraitRatio, setPortraitRatio] = useState<PortraitRatio>('freestyle');
    const [isDemoMode] = useState(true); // Always true for demo mode

    const value = {
        portraitRatio,
        setPortraitRatio,
        isDemoMode
    };

    return (
        <DemoContext.Provider value={value}>
            {children}
        </DemoContext.Provider>
    );
}

export function useDemo() {
    const context = useContext(DemoContext);
    if (context === undefined) {
        throw new Error('useDemo must be used within a DemoProvider');
    }
    return context;
}

// DEMO HOOK FOR EASY INTEGRATION
export const useDemoRatio = () => {
    const { portraitRatio, setPortraitRatio } = useDemo();

    return {
        portraitRatio,
        setPortraitRatio,
        isDemoMode: true
    };
};
